import { render, staticRenderFns } from "./EditPane.vue?vue&type=template&id=1bd4fdb7&scoped=true"
import script from "./EditPane.vue?vue&type=script&lang=js"
export * from "./EditPane.vue?vue&type=script&lang=js"
import style0 from "./EditPane.vue?vue&type=style&index=0&id=1bd4fdb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4fdb7",
  null
  
)

export default component.exports